import request from '@/utils/request';
export const defaultUnitData = {
  id: 0,
  enabled: true,
  name: '',
  code: '',
  numericCode: '',
  alias: '',
  unitType: '',
  sequence: '',
  admin: [],
  branchId: undefined,
  branch: {
    id: undefined
  },
  cityId: undefined,
  city: {
    id: undefined
  },
  stateId: undefined,
  state: {
    id: undefined
  },
  countryId: undefined,
  country: {
    id: undefined
  }
};
export const getUnits = params => request({
  url: '/units',
  method: 'get',
  params
});
export const getUnitById = id => request({
  url: `/units/${id}`,
  method: 'get'
});
export const getUnitByBranchId = id => request({
  url: `/units/unit-by-branch/${id}`,
  method: 'get'
});
export const updateUnit = (id, data) => request({
  url: `/units/${id}`,
  method: 'patch',
  data
});
export const deleteUnit = id => request({
  url: `/units/${id}`,
  method: 'delete'
});
export const createUnit = data => request({
  url: '/units',
  method: 'post',
  data
});